import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "concepts"
    }}>{`Concepts`}</h1>
    <p>{`Before you start developing scripts for InDesign in UXP, it's important to understand some basic concepts of UXP scripts. This section will introduce you to some of the most important concepts like script lifespan and global await.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      